import React, { Component } from 'react';
import '../../inc/genstyle.css';
import '../iinc/iStyle.css';
import '../iinc/iGlobal';
import DateTimeFormats from '../../inc/date-time-format';
import { FormErrors } from '../../inc/error-form';
import CheckBox from '../../inc/checkbox';
import WarningIcon from '@mui/icons-material/Warning';
import EditIcon from '@mui/icons-material/Edit';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[27];

class IReqRenewLicenceDetail extends Component {
    constructor (props) {
        super(props);
        this.state = {
            stPopTitle: '',
            requestdoc_id: '',
            clientdoc_id: '',
            licencedoc_id: '',
            
            client_name: '',
            domain_name: '',
            client_country: '',
            licence_type: '',
            licence_addseat: '',
            licence_currentseat: '',
            licence_current_addon: '',
            licence_addon_list: [],
            licence_addon_seat: [],
            licence_addon_list_input: [],
            licence_addon_seat_input: [],
            request_seat: '',
            request_addon: '',
            request_addon_seat: '',
            request_status: '',
            request_date: '',
            request_by: '',

            process_by: '',
            process_date: '',
            process_comment: '',
            completed_by: '',
            completed_date: '',
            completed_comment: '',
            cancel_by: '',
            cancel_date: '',
            cancel_comment: '',
            
            update_status: '',
            request_comment: '',
            formErrors: {update_status: '', licence_addseat: '', request_comment: ''},
            updateStatusValid: false,
            formValid: false,
            errmsg: '',
            contentoth: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.loadFormRequestData = this.loadFormRequestData.bind(this);
        this.resetErrorMsg = this.resetErrorMsg.bind(this);
    }
    loadFormRequestData() {
        var othersContent = JSON.parse(document.getElementById("contentoth").innerText);
        var requestId = othersContent.request_id;
        fetch(global.config.urlLink+"/reqrenewlicenceview/"+requestId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }
          }).then(res => {
            if(res.status === 200) 
                return res.json() 
          }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
                var resultContent = resJson.values.requestData[0].content[0].maincontent;
                var cDate = '', processBy='', processDate='', processComment='', completedBy='', completedDate='', completedComment='', cancelBy='', cancelDate='', cancelComment='';
                if(resultContent.createDate !== undefined) { cDate = DateTimeFormats(resultContent.createDate._seconds,"datetime-long"); }
                if(resultContent.processByName !== undefined) { processBy = resultContent.processByName; }
                if(resultContent.processDate !== undefined) { processDate = DateTimeFormats(resultContent.processDate._seconds,"datetime-long"); }
                if(resultContent.processRemarks !== undefined) { processComment = resultContent.processRemarks; }
                if(resultContent.completedByName !== undefined) { completedBy = resultContent.completedByName; }
                if(resultContent.completedDate !== undefined) { completedDate = DateTimeFormats(resultContent.completedDate._seconds,"datetime-long"); }
                if(resultContent.completedRemarks !== undefined) { completedComment = resultContent.completedRemarks; }
                if(resultContent.cancelByName !== undefined) { cancelBy = resultContent.cancelByName; }
                if(resultContent.cancelDate !== undefined) { cancelDate = DateTimeFormats(resultContent.cancelDate._seconds,"datetime-long"); }
                if(resultContent.cancelRemarks !== undefined) { cancelComment = resultContent.cancelRemarks; }
                
                var arrLicenceAddOn = [];
                if(resultContent.licenceRequestAddOn !== undefined && resultContent.licenceRequestAddOn !== "") {
                    var arrAddOnType = resultContent.licenceRequestAddOn.split("$$");
                    for(var b=0; b<arrAddOnType.length; b++) {
                        var arrAddOnTypeContent = arrAddOnType[b].split("|");
                        var checkResult = false;
                        if(arrAddOnTypeContent[1] === "true") { checkResult = true; }
                        arrLicenceAddOn = arrLicenceAddOn.concat({'id':b+1,'fieldId':'licence_addon_'+(b+1),'value':arrAddOnTypeContent[0],'label':arrAddOnTypeContent[0],'isChecked': checkResult,'isDisable': false});
                        
                    }
                }

                var arrLicenceAddOnSeat = [];
                if(resultContent.licenceRequestAddOnSeat !== undefined && resultContent.licenceRequestAddOnSeat !== "") {
                    var arrAddOnSeat = resultContent.licenceRequestAddOnSeat.split("$$");
                    for(var c=0; c<arrAddOnSeat.length; c++) {
                        var arrAddOnSeatContent = arrAddOnSeat[c].split("|");
                        var seatRequestValue = arrAddOnSeatContent[1]; 
                        if(seatRequestValue === "0") { seatRequestValue = ""; }
                        arrLicenceAddOnSeat = arrLicenceAddOnSeat.concat({'id':c+1,'fieldId':'licence_addon_seat_'+(c+1),'value':seatRequestValue,'label':arrAddOnSeatContent[0]});                    
                    }
                }

                this.setState({
                    stPopTitle: '',
                    requestdoc_id: resJson.values.requestData[0].docid,
                    clientdoc_id: resultContent.clientId,
                    licencedoc_id: resultContent.licenceId,

                    client_name: resultContent.clientName,
                    domain_name: resultContent.domainName,
                    client_country: resultContent.clientCountry,
                    licence_type: resultContent.licenceType,
                    licence_addseat: resultContent.licenceAddSeat,
                    licence_currentseat: resJson.values.licenceData[0].scontent[0].subcontent.licenceTotalSeat,
                    licence_current_addon: resultContent.licenceAddOn,
                    licence_addon_list: arrLicenceAddOn,
                    licence_addon_seat: arrLicenceAddOnSeat,
                    licence_addon_list_input: arrLicenceAddOn,
                    licence_addon_seat_input: arrLicenceAddOnSeat,
                    request_seat: resultContent.licenceRequestAddSeat,
                    request_addon: resultContent.licenceRequestAddOn,
                    request_addon_seat: resultContent.licenceRequestAddOnSeat,
                    request_status: resultContent.requestStatus,
                    request_date: cDate,
                    request_by: resultContent.createByName,
                    process_by: processBy,
                    process_date: processDate,
                    process_comment: processComment,
                    completed_by: completedBy,
                    completed_date: completedDate,
                    completed_comment: completedComment,
                    cancel_by: cancelBy,
                    cancel_date: cancelDate,
                    cancel_comment: cancelComment,
                    
                    update_status: '',
                    request_comment: '',
                    formErrors: {update_status: '', licence_addseat: '', request_comment: ''},
                    updateStatusValid: false,
                    formValid: false,
                    errmsg: '',
                    contentoth: document.getElementById("contentoth").innerText
                }); 
            } else {
                console.log('Something happened wrong');
            }
          }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
          }); 
        
    }
    resetErrorMsg() {
        this.setState({
            formErrors: {update_status: ''},
            updateStatusValid: false,
            formValid: false,
            errmsg: '' 
        }, this.validateForm);
        
    }
    urlcancelForm(valId,divId,exdivId) {
        document.getElementById(divId).style.display = "none";
        document.getElementById(exdivId).style.display = "block";        
    }
    urleditStatus(valId) {
        document.getElementById("request-edit-form").style.display = "block";
        document.getElementById("request-detail-info").style.display = "none";
        this.loadFormRequestData();
    }
    handleLicenceAddOn = (e) => {
        var stat = false;
        var licaddon = this.state.licence_addon_list_input;
        licaddon.forEach(licaddons => {
           if (licaddons.value === e.target.value) { licaddons.isChecked =  e.target.checked; }
           if(licaddons.isChecked === true) { stat = true; }
        })
        this.setState({
            licence_addon_list_input: licaddon
        }, () => { 
          this.validateField("licence_addon_list", stat)
        })
        
    } 
    handleUserInput2 = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        
        var licaddonseat = this.state.licence_addon_seat_input;
        licaddonseat.forEach(licaddonseats => {
           if (licaddonseats.fieldId === name) { licaddonseats.value =  value; }
        })
        this.setState({
            licence_addon_seat_input: licaddonseat
        })
    } 
    handleUserSelect = (e) => {
        const value = e.target.value;
        const inputname = e.target.name;
        this.setState({[inputname]: value},
            () => { this.validateField(inputname, value)});
    }
    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value},
            () => { this.validateField(name, value)});
    } 
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let updateStatusValid = this.state.updateStatusValid;
        
        switch(fieldName) {
            case 'update_status': 
                updateStatusValid = value.trim().length > 0;
                fieldValidationErrors.update_status = updateStatusValid ? '' : 'status need to be filled';
                break;
            default:
                break;
        }
        this.setState({formErrors: fieldValidationErrors,
                        updateStatusValid: updateStatusValid,
                    }, this.validateForm);                            
    }
    validateForm() {
        this.setState({formValid: this.state.updateStatusValid });
    }
    errorClass(error) {
        return(error.length === 0 ? '' : 'has-error');
    }
    handleSubmit(e) {
        e.preventDefault();
        if(this.state.update_status !== '') {
            document.getElementById('loading-area').style.display = 'block'; 

            var updatestatusval = "", licenceaddseatval = 0, requestcommentval ="";
            if(this.textInputUpdateStatus.value === '') { updatestatusval = this.state.update_status; } else { updatestatusval = this.textInputUpdateStatus.value; }
            if(this.textInputLicenceAddSeat.value === '') { licenceaddseatval = this.state.licence_addseat; } else { licenceaddseatval = this.textInputLicenceAddSeat.value; }
            if(this.textInputRequestComment.value === '') { requestcommentval = this.state.request_comment; } else { requestcommentval = this.textInputRequestComment.value; }
            
            var licenceAddOnList = "";
            if(this.state.licence_type === global.cconfig.typeLicenceAddon) {
                for(var al=0; al<this.state.licence_addon_list_input.length; al++) {
                    if(licenceAddOnList !== "") { licenceAddOnList += "$$"; }
                    var seatval = 0;
                    for(var as=0; as<this.state.licence_addon_seat_input.length; as++) {
                        if(this.state.licence_addon_list_input[al].label === this.state.licence_addon_seat_input[as].label) {
                            if(this.state.licence_addon_seat_input[as].value !== "") { seatval = this.state.licence_addon_seat_input[as].value; break; }
                        }
                    }
                    licenceAddOnList += this.state.licence_addon_list_input[al].label+"|"+this.state.licence_addon_list_input[al].isChecked+"|"+seatval;
                }
            }
            var urlFetch, datatext;
            datatext ='{"request_id":"'+this.state.requestdoc_id+'","client_id":"'+this.state.clientdoc_id+'","licence_id":"'+this.state.licencedoc_id+'","update_status":"'+updatestatusval+'","licence_addseat":"'+licenceaddseatval+'","request_comment":"'+requestcommentval+'","current_seat":"'+this.state.licence_currentseat+'","form_id":"form-updatestatus-renew","licence_addon":"'+licenceAddOnList+'"}';
            urlFetch = global.config.urlLink+"/updatereqrenewlicence";
            
            var data = JSON.parse(datatext); 
            fetch(urlFetch, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': authKey,
                }, body : JSON.stringify(data)
            }).then(res => {
                if(res.status === 200) 
                    return res.json() 
            }).then( resJson => {
                document.getElementById('loading-area').style.display = 'none'; 
                document.getElementById('request-edit-form').style.display = 'none';
                document.getElementById('request-detail-info').style.display = 'block';
                if(resJson.status === '200') {
                    window.location.href='/irenewlicence';
                } else {
                    console.log('Something happened wrong');
                }
            }).catch(err => {
                document.getElementById('loading-area').style.display = 'none'; 
            }) ;
            
        } else {
            var arrfieldName = ['update_status'];
            var arrvalue = [this.textInputUpdateStatus.value];
            for(var ck in arrfieldName) {
                this.validateField(arrfieldName[ck], arrvalue[ck]);
            }
          }      
    }
    componentDidMount() {
        document.getElementById('loading-area').style.display = 'block'; 
        document.getElementById("errormsg").style.display = 'none';
        this.loadFormRequestData();
    }
    currentlicaddon() {
        var arrResultCurrentLicenceAddOn = [];
        if(this.state.licence_current_addon !== undefined && this.state.licence_current_addon !== "") {
            var arrCurrentAddOn = this.state.licence_current_addon.split("$$");
            for(var ac=0; ac<arrCurrentAddOn.length; ac++) {
                var arrCurrentAddOnContent = arrCurrentAddOn[ac].split("|");
                if(arrCurrentAddOnContent[1] === "true") {
                    arrResultCurrentLicenceAddOn.push(<li key={ac}>{arrCurrentAddOnContent[0]} : {arrCurrentAddOnContent[2]} seat(s)</li>)
                }
            }
        }
        return arrResultCurrentLicenceAddOn;
    }
    licaddon() { 
        var arrResultLicenceAddOn = [];
        if(this.state.request_addon !== undefined && this.state.request_addon !== "" 
            && this.state.request_addon_seat !== undefined && this.state.request_addon_seat !== "" 
          ) {
            var arrLicenceAddOn = this.state.request_addon.split("$$");
            var arrLicenceAddOnSeat = this.state.request_addon_seat.split("$$");
            for(var ao=0; ao<arrLicenceAddOn.length; ao++) {
                var arrLicenceAddOnContent = arrLicenceAddOn[ao].split("|");
                if(arrLicenceAddOnContent[1] === "true") {
                    var addonSeatVal = 0;
                    if(arrLicenceAddOnSeat.length>0) {
                        for(var aod=0; aod<arrLicenceAddOnSeat.length; aod++) {
                            var arrLicenceAddOnSeatContent = arrLicenceAddOnSeat[aod].split("|");
                            if(arrLicenceAddOnSeatContent[0] === arrLicenceAddOnContent[0]) { addonSeatVal = arrLicenceAddOnSeatContent[1]; break; }
                        }
                    }
                    arrResultLicenceAddOn.push(<li key={ao}>{arrLicenceAddOnContent[0]} : {addonSeatVal} seat(s)</li>)
                }
            }
        }
        return arrResultLicenceAddOn;
    }
    inputlicaddonseat() {
        var arrinputLicAddOnSeat = [];
        if(this.state.licence_addon_seat.length > 0) {
          for(var ls4=0; ls4<this.state.licence_addon_seat.length; ls4++) {
            arrinputLicAddOnSeat.push(<div className="mgB10" key={ls4}>
                <input type="number" className="form-control" 
                  name={this.state.licence_addon_seat[ls4].fieldId}
                  value={this.state.licence_addon_seat[ls4].value}
                  onChange={this.handleUserInput2}  
                  min="1"/> 
              </div>
            )
          }
        }
        return arrinputLicAddOnSeat;
      }
    render() {
        var currentLicAddOn = this.currentlicaddon();
        var licAddOnList = this.licaddon();
        var inputLicAddOnSeat = this.inputlicaddonseat();

        return (
            <div className="main-container">
                <div className="mgT20">
                <div className="divhide w100p" id="errormsg"><WarningIcon severity="error" />{this.state.errmsg}</div>
                  <div className="mgL20 st3Title">{this.state.client_name}</div>
                  <div className="mgL20 flex-container">
                    <div className="w70p"><h5 className="detailJoined">{this.state.client_country} - {this.state.domain_name}</h5></div>
                    {(this.state.request_status === global.config.requestStatus[0] || this.state.request_status === global.config.requestStatus[1])?
                    <div className="w30p divRight">
                        <div className="mgR30 linkText cursor-on" onClick={this.urleditStatus.bind(this, this.state.renewdoc_id)}><EditIcon className="mgR05" style={{fontSize:"14pt"}} ></EditIcon><span style={{marginTop:"3px"}}>Edit Status &raquo;</span></div>
                    </div>
                    : ''}
                  </div>
                  <div className="mgT20 mgL20">
                    {/* ---- */}
                    <div>
    
                    { /* --------- */ }
                        <div className="mgT20 divHide" id="request-edit-form">
                        <form id="form-renew-edit" onSubmit={this.handleSubmit}>
                            <div className="smallForm">
                                
                                <div className="flex-container mgT10">
                                    <div className="w40p"><label className="mgT05" htmlFor="update_status">Update Status</label></div>
                                    <div className="w60p">
                                        <select name="update_status" className="form-control" 
                                            value={this.state.update_status} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputUpdateStatus = input}
                                        >
                                            <option value="">-- please select --</option>
                                            <option value={global.config.requestStatus[1]}>{global.config.requestStatus[1]}</option>
                                            <option value={global.config.requestStatus[2]}>{global.config.requestStatus[2]}</option>
                                            <option value={global.config.requestStatus[3]}>{global.config.requestStatus[3]}</option>
                                        </select>
                                        <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.update_status}/>  }</div>
                                    </div>
                                </div>
                                <div className="flex-container mgT10">
                                    <div className="w40p"><label className="mgT10" htmlFor="licence_addseat">Amount of Seats </label></div>
                                    <div className="w60p flex-container">
                                        <div>
                                            <input type="number" className="form-control" name="licence_addseat"
                                                placeholder={this.state.licence_addseat}
                                                value={this.state.licence_addseat}
                                                onChange={this.handleUserInput}  
                                                ref={(input) => this.textInputLicenceAddSeat = input}
                                                min="1"/> 
                                            <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.licence_addseat}/>  }</div>
                                        </div>
                                        <div className="mgL20 mgT10"> seat(s) </div>
                                    </div>
                                </div>
                                {(this.state.licence_type === global.config.typeLicenceAddon)?
                                <div className="flex-container mgT10">
                                    <div className="w40p"><label className="mgT10" htmlFor="licence_addseat">Add On Licence </label></div>
                                    <div className="w60p flex-container">
                                        <div className="mgR20">
                                            {
                                            this.state.licence_addon_list.map((licence_addon, index) => {
                                                return (<div className="divMiddle mgB10" style={{height:"38px"}}><CheckBox key={index} handleInputChecked={this.handleLicenceAddOn}  {...licence_addon} /></div>)
                                            })
                                            }
                                        </div>
                                        <div>
                                        {inputLicAddOnSeat}
                                        </div>
                                    </div>
                                </div>
                                : ''}
                                <div className="mgT10 textBold">Remarks</div>
                                <div className="mgT05">
                                    <textarea name="request_comment" className="form-control" 
                                        rows={3} cols={30} 
                                        value={this.state.request_comment} 
                                        onChange={this.handleUserInput} 
                                        ref={(input) => this.textInputRequestComment = input}
                                    />
                                    <div className="mgT05">{ <FormErrors formErrors={this.state.formErrors.request_comment}/>  }</div>
                                </div>
                                <div className="mgT30 divCenter">
                                    <div className="flex-container">
                                    <button type="submit" className="submitButton mgR20">Submit</button>
                                    <div className="submitButton cursor-on" onClick={this.urlcancelForm.bind(this, this.state.memberdoc_id, "request-edit-form", "request-detail-info")}>Cancel</div>
                                    </div>
                                </div>
    
                            </div>
                        </form>
                        </div>
                        { /* --------- */ }

                        <div className="mgT05" id="request-detail-info">
                            <div className="mgT20 flex-container">
                                <div className="w30p">Type of Licence </div>
                                <div className="mgL10"> {this.state.licence_type}</div>
                            </div>
                            <div className="mgT20 flex-container">
                                <div className="w30p">Request on </div>
                                <div className="mgL10"> {this.state.request_date} <span className="mgL30">by.</span><span className="mgL10"> {this.state.request_by}</span></div>
                            </div>
                            <div className="mgT05 flex-container" >
                                <div className="w30p">Current Status </div>
                                <div className="mgL10 st4Title"> <span className={this.state.request_status === global.config.requestStatus[2]? "fontGreen textBold" : "textBold"}>{this.state.request_status}</span> </div>
                            </div>
                            <div className="mgT20" style={{borderBottom:"solid 1px #CCCCCC"}}></div>
                            <div className="row mgT20">
                                <div className="col-sm mgR10">
                                    <div className="textBold">Request</div>
                                    <div className="mgT05 flex-container">
                                        <div className="w30p">Seat</div>
                                        <div className="mgL10"> {this.state.request_seat} seat(s)</div>
                                    </div>
                                    {(this.state.licence_type === global.config.typeLicenceAddon)?
                                    <div className="mgT05 flex-container">
                                        <div className="w30p">Add On</div>
                                        <div className="mgL10"> {(licAddOnList.length>0)? licAddOnList : '-'}</div>
                                    </div>
                                    : ''}
                                </div>
                                <div className="col-sm mgL10">
                                    {(this.state.request_status === global.config.requestStatus[2])?
                                    <div>
                                        <div className="textBold">Confirmed</div>
                                        <div className="mgT05 flex-container">
                                            <div className="w30p">Seat</div>
                                            <div className="mgL10"> {this.state.licence_addseat} seat(s)</div>
                                        </div>
                                        {(this.state.licence_type === global.config.typeLicenceAddon)?
                                        <div className="mgT05 flex-container">
                                            <div className="w30p">Add On</div>
                                            <div className="mgL10"> {(currentLicAddOn.length>0)? currentLicAddOn : '-'}</div>
                                        </div>
                                        : ''}
                                    </div>
                                    : '' }
                                </div>
                            </div>
                            
                            
                            
                            {(this.state.process_by !== '' || this.state.completed_by !== '' || this.state.cancel_by !== '')? 
                            <div>
                                <div className="mgT30">
                                    <div className="textBold">Detail Information</div>
                                </div>
                                <div className="row">
                                {(this.state.process_by !== '')? 
                                    <div className="col-sm mgL10 mgR10 picContainer">
                                        <div className="textBold">In Process</div>
                                        <div className="mgT10 smText">By : {this.state.process_by}</div>
                                        <div className="mgT10 smText">On : {this.state.process_date} </div>
                                        {(this.state.process_comment !== '')? 
                                        <div className="mgT10 smText">Remarks : <br/>{this.state.process_comment}</div>
                                        : ''}
                                    </div>
                                : ''}
                                {(this.state.completed_by !== '')? 
                                    <div className="col-sm mgL10 mgR10 picContainer">
                                        <div className="textBold">Completed</div>
                                        <div className="mgT10 smText">By : {this.state.completed_by}</div>
                                        <div className="mgT10 smText">On : {this.state.completed_date} </div>
                                        {(this.state.completed_comment !== '')? 
                                        <div className="mgT10 smText">Remarks : <br/>{this.state.completed_comment}</div>
                                        : ''}
                                    </div>
                                : ''}
                                {(this.state.cancel_by !== '')? 
                                    <div className="col-sm mgL10 mgR10 picContainer">
                                        <div className="textBold">Cancel</div>
                                        <div className="mgT10 smText">By : {this.state.cancel_by}</div>
                                        <div className="mgT10 smText">On : {this.state.cancel_date} </div>
                                        {(this.state.cancel_comment !== '')? 
                                        <div className="mgT10 smText">Remarks : <br/>{this.state.cancel_comment}</div>
                                        : ''}
                                    </div>
                                : ''}
                                </div>
                            </div>
                            : ''}
                        </div> 
                        
                        
                        
                    </div>
    
                    {/* ---- */}
                    
                  </div>
                  <div className="row-field mgB30">
                        
                  </div>
                </div>
                <div id="loading-area" className="divHide loading"></div> 
            </div>
          );
    }
}

export default IReqRenewLicenceDetail;